import axiosInstance from "./axiosInstance";
export const fetchTeamMembers = async (params={}) => {
  try {
    const response = await axiosInstance.get(`/api/user/team_member`,{
        params:params
    });
    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
export const fetchTeamMembersByIds = async (params={}) => {
  try {
    const response = await axiosInstance.get(`/api/user/team/team_users`,{
        params:params
    });
    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
